<template>
  <div class="ab-btn" :style="{ '--width': width, '--height': height }">
    <slot>
      <a
        data-source="p"
        onmouseover="linkDataSource(this)"
        @click="showModal"
        a-type="register"
        target="_blank"
        >立刻体验</a
      >
    </slot>
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import inquiryModalVue from "@/components/InquiryModal2.vue";
import { usePageTracker } from "@/utils/pageTracker";
export default {
  components: {
    inquiryModalVue,
  },
  props: {
    width: {
      type: String,
      default: "180px",
    },
    height: {
      type: String,
      default: "60px",
    },
    classStyle: {
      type: String,
      default: "",
    },
  },
  data: function() {
    return {
      widthVal: this.width, // item 的宽度
      heightVal: this.height,
      classVal: this.classStyle,
      visible: false,
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass">
.ab-btn{
  margin: 0 auto;
  width: 200px;
  height: 64px;
  background: linear-gradient(230deg, #198BFF 0%, #217AF9 100%);
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  line-height:64px;
  color:#fff;
  font-family: 'Alibaba-PuHuiTi-R';
  font-size: 20px;

  & a{
    color:#fff;
    font-size: 20px;
    font-family: 'Alibaba-PuHuiTi-R';
    display: block;
  }
}
.ab-btn:hover{
    background:#0d6aef
}
</style>
